import { render, staticRenderFns } from "./NextCompensationPlugin.vue?vue&type=template&id=70e9273c&scoped=true&"
import script from "./NextCompensationPlugin.vue?vue&type=script&lang=ts&"
export * from "./NextCompensationPlugin.vue?vue&type=script&lang=ts&"
import style0 from "./NextCompensationPlugin.vue?vue&type=style&index=0&id=70e9273c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9273c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDivider,VIcon,VSpacer})
